var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-carousel',{attrs:{"height":"400","interval":3000,"cycle":""}},_vm._l((_setup.items),function(src,i){return _c('v-carousel-item',{key:i,attrs:{"src":src,"transition":"cross-scale","reverse-transition":"cross-scale","cover":""}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }